export default __webpack_public_path__ + "static/Karla-BoldItalic-47d76504987f0c00be73d3c5c66aaf25.woff2";